// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"762":"8f472607","787":"cba1bacf"}[chunkId] + ".chunk.js";
};